import { server_connection } from 'config';

export const TOGGLE_MONTH = '[COURSE APP] TOGGLE MONTH';
export const DROP_MODULE_TO_DAY = '[COURSE APP] DROP MODULE TO DAY';
export const DROP_LESSON_TO_DAY = '[COURSE APP] DROP LESSON TO DAY';
export const DROP_ORPHAN_LESSON = '[COURSE APP] DROP ORPHAN COURSE';
export const CHECK_DUPLICATE_LESSON_CONFLICT = '[COURSE APP] CHECK DUPLICATE LESSON CONFLICT';
export const CHECK_DAY_LESSON_CONFLICT = '[COURSE APP] CHECK DAY LESSON CONFLICT';
export const HANDLE_DUPLICATE_CHECK_CHANGE = '[COURSE APP] HANDLE DUPLICATE CHECK CHANGE';
export const HANDLE_OVERWRITE_CHECK_CHANGE = '[COURSE APP] HANDLE OVERWRITE CHECK CHANGE';
export const HANDLE_DUPLICATE_SUBMIT = '[COURSE APP] HANDLE DUPLICATE SUBMIT';
export const HANDLE_OVERWRITE_SUBMIT = '[COURSE APP] HANDLE OVERWRITE SUBMIT';
export const REMOVE_LESSON_FROM_CALENDAR = '[COURSE APP] REMOVE LESSON FROM CALENDAR';
export const REMOVE_MODULE_FROM_CALENDAR = '[COURSE APP] REMOVE MODULE FROM CALENDAR';
export const TOGGLE_CONFIRM_DRAG_DIALOG = '[COURSE APP] TOGGLE CONFIRM DRAG DIALOG';
export const CONFIRM_DRAG_ALLOW = '[COURSE APP] CONFIRM DRAG ALLOW';
export const MODULE_PREVIEW = '[COURSE APP] MODULE PREVIEW';

export function toggleMonth(direction) {
    return {
        type: TOGGLE_MONTH,
        payload: direction
    }
}

// export function dropModuleToDay(module, week, day, course_id, dayValue, lessons) {
//     // console.log(module, week, day, course_id, dayValue)
//     return (dispatch) => {
//         return fetch(server_connection + '/module/get_lessons/' + module.module_id)
//             .then((response) => response.json())
//             .then((lessons) => {
//                 return dispatch({
//                     type: DROP_MODULE_TO_DAY,
//                     payload: {
//                         module: module,
//                         week: week,
//                         day: day,
//                         course_id: course_id,
//                         dayValue: dayValue,
//                         lessons: lessons
//                     }
//                 })
//             })
//     }
// }

export function dropModuleToDay(module, week, day, course_id, dayValue, lessons) {
    return {
        type: DROP_MODULE_TO_DAY,
        payload: {
            module: module,
            week: week,
            day: day,
            course_id: course_id,
            dayValue: dayValue,
            lessons: lessons
        }
    }
}

export function checkDuplicateLessonConflict(module, week, day, course_id, dayValue) {
    // console.log(module, week, day, course_id, dayValue)
    return (dispatch) => {
        return fetch(server_connection + '/module/get_lessons/' + module.module_id)
            .then((response) => response.json())
            .then((lessons) => {
                dispatch({
                    type: CHECK_DUPLICATE_LESSON_CONFLICT,
                    payload: {
                        module: module,
                        week: week,
                        day: day,
                        course_id: course_id,
                        dayValue: dayValue,
                        lessons: lessons
                    }
                })
                dispatch(dropModuleToDay(module, week, day, course_id, dayValue, lessons))
            })
    }
}


export function dropLessonToDay(lesson, week, day) {
    return {
        type: DROP_LESSON_TO_DAY,
        payload: {
            week: week,
            day: day,
            lesson: lesson
        }
    }
}

export function handleDuplicateCheckChange(lesson_id, selected) {
    return {
        type: HANDLE_DUPLICATE_CHECK_CHANGE,
        payload: {
            lesson_id: lesson_id,
            selected: selected
        }
    }
}

export function handleDuplicateSubmit() {
    return {
        type: HANDLE_DUPLICATE_SUBMIT,
        payload: null
    }
}

export function removeLessonFromCalendar(lesson) {
    return {
        type: REMOVE_LESSON_FROM_CALENDAR,
        payload: lesson
    }
}

export function removeModuleFromCalendar(module_id) {
    return {
        type: REMOVE_MODULE_FROM_CALENDAR,
        payload: module_id
    }
}

export function toggleConfirmDragDialog(lesson, week, day) {
    return {
        type: TOGGLE_CONFIRM_DRAG_DIALOG,
        payload: {
            setting: true,
            lesson: lesson,
            week: week,
            day: day
        }
    }
}

export function confirmDragAllow(setting) {
    return {
        type: CONFIRM_DRAG_ALLOW,
        payload: setting
    }
}

export function checkDayLessonConflict(module, week, day, course_id, dayValue) {
    return (dispatch) => {
        return fetch(server_connection + '/module/get_lessons/' + module.module_id)
            .then((response) => response.json())
            .then((lessons) => {
                dispatch({
                    type: CHECK_DAY_LESSON_CONFLICT,
                    payload: {
                        module: module,
                        week: week,
                        day: day,
                        course_id: course_id,
                        dayValue: dayValue,
                        lessons: lessons
                    }
                })
                dispatch(checkDuplicateLessonConflict(module, week, day, course_id, dayValue, lessons))
            })
    }
}

export function handleOverwriteCheckChange(week, day, selected) {
    return {
        type: HANDLE_OVERWRITE_CHECK_CHANGE,
        payload: {
            week: week,
            day: day,
            selected: selected
        }
    }
}

export function handleOverwriteSubmit() {
    return {
        type: HANDLE_OVERWRITE_SUBMIT,
        payload: null
    }
}

export function dropOrphanLesson(lesson, week, day, course_id) {
    return {
        type: DROP_ORPHAN_LESSON,
        payload: {
            lesson: lesson,
            week: week,
            day: day,
            course_id: course_id
        }
    }
}

export function modulePreview(module_id) {
    return (dispatch) => {
        return fetch(server_connection + '/module/get_lessons/' + module_id)
            .then((response) => response.json())
            .then((lessons) => {
                dispatch({
                    type: MODULE_PREVIEW,
                    payload: {
                        module_id: module_id,
                        lessons: lessons
                    }
                })
            })
    }
}


// WEBPACK FOOTER //
// src/main/content/course/store/actions/course.schedule.actions.js